import React from 'react';
import {
  ChatAutoComplete,
  EmojiIconLarge,
  EmojiPicker,
  Tooltip,
  useMessageInputContext,
  useChannelStateContext,
  useTranslationContext,
  UploadsPreview,
  FileUploadIconFlat,
} from 'stream-chat-react';
import CustomSendButtonSVG from './customSendButton';
import { FileUploadButton } from 'react-file-utils';
export const CustomMessageInput = () => {
  const { t } = useTranslationContext();

  const {
    closeEmojiPicker,
    emojiPickerIsOpen,
    handleEmojiKeyDown,
    handleSubmit,
    numberOfUploads,
    uploadNewFiles,
    openEmojiPicker,
  } = useMessageInputContext();

  const {
    acceptedFiles,
  } = useChannelStateContext;


  const handleCustomSendButtonClick = () => {
    if (handleSubmit) {
      handleSubmit(event);
    }
  };

  return (
    <div className='str-chat__input-flat str-chat__input-flat--send-button-active'>
      
      <div className='str-chat__input-flat-wrapper'>
      <UploadsPreview  />
        <div className='str-chat__input-flat--textarea-wrapper'>
          <ChatAutoComplete />
          <div className='str-chat__emojiselect-wrapper'>
            <Tooltip>
              {emojiPickerIsOpen ? t('Close emoji picker') : t('Open emoji picker')}
            </Tooltip>
            <span
              className='str-chat__input-flat-emojiselect'
              onClick={emojiPickerIsOpen ? closeEmojiPicker : openEmojiPicker}
              onKeyDown={handleEmojiKeyDown}
              role='button'
              tabIndex={0} >
              <EmojiIconLarge />
            </span>
          </div>
          <EmojiPicker />
          <div className='str-chat__fileupload-wrapper' data-testid='fileinput'>
                <Tooltip>
                  {t('Attach Files')}
                </Tooltip>
                <FileUploadButton
                  accepts={acceptedFiles}
                  disabled={numberOfUploads  === 1}
                  handleFiles={uploadNewFiles} >
                  <span className='str-chat__input-flat-fileupload'>
                    <FileUploadIconFlat />
                  </span>
                </FileUploadButton>
              </div>
        </div>
        <CustomSendButtonSVG onClick={handleCustomSendButtonClick} />
      </div>

    </div>
    
  );
};
